// extracted by css-extract-rspack-plugin
export default {"tutorial__body":"tutorial__body-Y68jMT","tutorialBody":"tutorial__body-Y68jMT","tutorial__container":"tutorial__container-fvmmbQ","tutorialContainer":"tutorial__container-fvmmbQ"};